import * as Api from 'src/components/LandingPage/MarketDesignMobile/ApiLayer';
import * as Deployment from 'src/components/LandingPage/MarketDesignMobile/Deployment';
import * as EcoSystem from 'src/components/LandingPage/MarketDesignMobile/EcoSystem';
import * as Exchanges from 'src/components/LandingPage/MarketDesignMobile/Exchanges';
import * as Initial from 'src/components/LandingPage/MarketDesignMobile/InitialLayer';
import * as Market from 'src/components/LandingPage/MarketDesignMobile/Market';
import * as Simulation from 'src/components/LandingPage/MarketDesignMobile/Simulation';

import { ELayersGroup, TLayers } from 'src/pages/MarketDesignMobile';

import s from './MarketDesign.module.scss';

/**
 *  LAYERS
 *  --------------------
 *  Object containing:
 *  1 - Component = Component to render
 *  2 - config = configurations
 *    if to be sticky then set stycky configurations ps.:
 *    sticky: { start: INITIAL_LAYER, end: END_LAUYER }
 *
 *    if to be a normal layer then use offset as a layer number
 *
 *  3 - props = if necessary there is a props available called withLayers
 *      that we can set an array of layers which will be available that layer
 */

export const InitialLayer: TLayers[] = [
  {
    Component: Initial.InitialLayer,
    config: { offset: 0, className: s.parallaxLayer },
  },
  {
    Component: Initial.MainTitle,
    config: { offset: 0, className: s.layerTitle },
  },
  // {
  //   Component: Initial.SelectedTitle,
  //   config: { sticky: { start: 1, end: 16 }, className: s.layerTitle },
  // },
];

export const BlueBoxLayer: TLayers[] = [
  {
    Component: Exchanges.BlueBoxOne,
    config: { sticky: { start: 2, end: 2 } },
  },
  {
    Component: Exchanges.BlueBoxTwo,
    config: { sticky: { start: 4, end: 4 } },
  },
  {
    Component: Exchanges.BlueBoxThree,
    config: { sticky: { start: 6, end: 6 } },
  },
  {
    Component: Exchanges.BlueBoxFour,
    config: { sticky: { start: 8, end: 8 } },
  },
  {
    Component: Market.BlueBoxOne,
    config: { sticky: { start: 10, end: 10 } },
  },
  {
    Component: Market.BlueBoxTwo,
    config: { sticky: { start: 12, end: 12 } },
  },
  {
    Component: Market.BlueBoxThree,
    config: { sticky: { start: 14, end: 14 } },
  },
  {
    Component: Market.BlueBoxFour,
    config: { sticky: { start: 16, end: 16 } },
  },
  {
    Component: Api.BlueBoxOne,
    config: { sticky: { start: 18, end: 18 } },
  },
  {
    Component: Api.BlueBoxTwo,
    config: { sticky: { start: 20, end: 20 } },
  },
  {
    Component: Simulation.BlueBoxOne,
    config: { sticky: { start: 22, end: 22 } },
  },
  {
    Component: Simulation.BlueBoxTwo,
    config: { sticky: { start: 24, end: 24 } },
  },
  {
    Component: Simulation.BlueBoxThree,
    config: { sticky: { start: 27, end: 27 } },
  },
  {
    Component: Simulation.BlueBoxFour,
    config: { sticky: { start: 29, end: 29 } },
  },
  {
    Component: Deployment.BlueBoxOne,
    config: { sticky: { start: 31, end: 31 } },
  },
];

export const ExchangeLayer: TLayers[] = [
  {
    Component: Exchanges.LightBarBlue,
    config: { sticky: { start: 1, end: 3 } },
  },
  {
    Component: Exchanges.ShadowBlue,
    config: { sticky: { start: 1, end: 3 } },
  },
  {
    Component: Exchanges.TooltipHouseBlue,
    config: { sticky: { start: 1, end: 2 } },
  },
  {
    Component: Exchanges.HouseBlue,
    config: { sticky: { start: 1, end: 4 } },
  },
  {
    Component: Exchanges.SolarPanel,
    config: { sticky: { start: 1, end: 4 } },
  },
  {
    Component: Exchanges.Car,
    config: { sticky: { start: 1, end: 4 } },
  },
  {
    Component: Exchanges.Battery,
    config: { sticky: { start: 1, end: 4 } },
  },
  {
    Component: Exchanges.Consumption,
    config: { sticky: { start: 1, end: 4 } },
  },
  {
    Component: Exchanges.TooltipDiamond,
    config: { sticky: { start: 3, end: 4 } },
  },
  {
    Component: Exchanges.Diamond,
    config: { sticky: { start: 3, end: 4 } },
  },
  {
    Component: Exchanges.SingleCommunity,
    config: { sticky: { start: 5, end: 8 } },
  },
  {
    Component: Exchanges.LineDiamondCommunity,
    config: { sticky: { start: 5, end: 6 } },
  },
  {
    Component: Exchanges.TooltipDiamondCommunity,
    config: { sticky: { start: 5, end: 6 } },
  },
  {
    Component: Exchanges.TooltipCommunityAppears,
    config: { sticky: { start: 7, end: 8 } },
  },
  {
    Component: Exchanges.CommunityAppears,
    config: { sticky: { start: 7, end: 8 } },
  },
  {
    Component: Exchanges.Subtitle,
    config: { sticky: { start: 1, end: 8 } },
  },
];

export const MarketLayer: TLayers[] = [
  {
    Component: Market.MarketOne,
    config: { sticky: { start: 9, end: 10 } },
  },
  {
    Component: Market.Voltage,
    config: { sticky: { start: 9, end: 10 } },
  },
  {
    Component: Market.GrayBox,
    config: { sticky: { start: 9, end: 10 } },
  },
  {
    Component: Market.TooltipMarketTwo,
    config: { sticky: { start: 11, end: 12 } },
  },
  {
    Component: Market.MarketTwo,
    config: { sticky: { start: 11, end: 12 } },
  },
  {
    Component: Market.TooltipMarketThree,
    config: { sticky: { start: 13, end: 14 } },
  },
  {
    Component: Market.MarketThree,
    config: { sticky: { start: 13, end: 14 } },
  },
  {
    Component: Market.MarketNextLevel,
    config: { sticky: { start: 15, end: 16 } },
  },
  {
    Component: Market.TooltipNextTooltip,
    config: { sticky: { start: 15, end: 16 } },
  },
];

export const ApiLayer: TLayers[] = [
  {
    Component: Api.ApiOne,
    config: { sticky: { start: 17, end: 18 } },
  },
  {
    Component: Api.SubtitleApiOne,
    config: { sticky: { start: 17, end: 18 } },
  },
  {
    Component: Api.TooltipApiTwo,
    config: { sticky: { start: 19, end: 20 } },
  },
  {
    Component: Api.SubtitleApiTwo,
    config: { sticky: { start: 19, end: 20 } },
  },
  {
    Component: Api.ApiTwo,
    config: { sticky: { start: 19, end: 20 } },
  },
];

export const SimulationLayer: TLayers[] = [
  {
    Component: Simulation.GrayBoxOne,
    config: { sticky: { start: 21, end: 22 } },
  },
  {
    Component: Simulation.SimulationOne,
    config: { sticky: { start: 21, end: 22 } },
  },
  {
    Component: Simulation.SimulationBox,
    config: { sticky: { start: 23, end: 26 } },
  },
  {
    Component: Simulation.GrayBoxTwo,
    config: { sticky: { start: 23, end: 24 } },
  },
  {
    Component: Simulation.SimulationTwo,
    config: { sticky: { start: 23, end: 24 } },
  },
  {
    Component: Simulation.GrayBoxThree,
    config: { sticky: { start: 25, end: 26 } },
  },
  {
    Component: Simulation.SimulationThree,
    config: { sticky: { start: 25, end: 26 } },
  },
  {
    Component: Simulation.GrayBoxFour,
    config: { sticky: { start: 28, end: 29 } },
  },
  {
    Component: Simulation.SimulationFour,
    config: { sticky: { start: 28, end: 29 } },
  },
];

export const DeploymentLayer: TLayers[] = [
  {
    Component: Simulation.SimulationBox,
    config: { sticky: { start: 30, end: 31 } },
  },
  {
    Component: Deployment.City,
    config: { sticky: { start: 30, end: 31 } },
  },
  {
    Component: Deployment.Ring,
    config: { sticky: { start: 30, end: 31 } },
  },
  {
    Component: Deployment.GrayBox,
    config: { sticky: { start: 30, end: 31 } },
  },
];

export const EcosystemLayer: TLayers[] = [
  // testing layer
  {
    Component: EcoSystem.EcoSystemMain,
    config: { sticky: { start: 32, end: 32 } },
  },
];

function normalizeLayerValue(layer: TLayers, where = 'start') {
  if (layer?.config?.sticky?.[where] === 0) {
    return 0;
  }
  return layer?.config?.sticky?.[where] || layer?.config?.offset;
}

const range = (min, max) => Array.from({ length: max - min + 1 }, (_, i) => min + i);

export const layerPositions = {
  [ELayersGroup.INITIAL]: normalizeLayerValue(InitialLayer?.[0]),
  [ELayersGroup.EXCHANGES]: normalizeLayerValue(ExchangeLayer?.[0]),
  [ELayersGroup.MARKETS]: normalizeLayerValue(MarketLayer?.[0]),
  [ELayersGroup.APIS]: normalizeLayerValue(ApiLayer?.[0]),
  [ELayersGroup.SIMULATION]: normalizeLayerValue(SimulationLayer?.[0]),
  [ELayersGroup.DEPLOYMENT]: normalizeLayerValue(DeploymentLayer?.[0]),
  [ELayersGroup.ECOSYSTEM]: normalizeLayerValue(EcosystemLayer?.[0]),
};

export const totalLayersInEachGroup = {
  [ELayersGroup.INITIAL]: normalizeLayerValue(InitialLayer?.[0]),
  [ELayersGroup.EXCHANGES]: range(
    normalizeLayerValue(ExchangeLayer?.[0]),
    normalizeLayerValue(ExchangeLayer?.[ExchangeLayer.length - 1], 'end'),
  ),
  [ELayersGroup.MARKETS]: range(
    normalizeLayerValue(MarketLayer?.[0]),
    normalizeLayerValue(MarketLayer?.[MarketLayer.length - 1], 'end'),
  ),
  [ELayersGroup.APIS]: range(
    normalizeLayerValue(ApiLayer?.[0]),
    normalizeLayerValue(ApiLayer?.[ApiLayer.length - 1], 'end'),
  ),
  [ELayersGroup.SIMULATION]: range(
    normalizeLayerValue(SimulationLayer?.[0]),
    normalizeLayerValue(SimulationLayer?.[SimulationLayer.length - 1], 'end'),
  ),
  [ELayersGroup.DEPLOYMENT]: range(
    normalizeLayerValue(DeploymentLayer?.[0]),
    normalizeLayerValue(DeploymentLayer?.[DeploymentLayer.length - 1], 'end'),
  ),
  [ELayersGroup.ECOSYSTEM]: range(
    normalizeLayerValue(EcosystemLayer?.[0]),
    normalizeLayerValue(EcosystemLayer?.[EcosystemLayer.length - 1], 'end'),
  ),
};

const allLayers = [
  ...InitialLayer,
  ...ExchangeLayer,
  ...MarketLayer,
  ...ApiLayer,
  ...SimulationLayer,
  ...DeploymentLayer,
  ...EcosystemLayer,
];

// show the numbers of layers
export const totalPages = normalizeLayerValue(allLayers?.[allLayers?.length - 1], 'end');
